class ReviewRating extends HTMLElement {
  connectedCallback() {
    this.positionSelf();
  }

  positionSelf() {
    if (this.dataset.positioned === 'true') return;
    if (this.dataset.position !== 'above-price') return;

    const card = this.closest('product-card') || this.closest('.product-card');
    if (!card) return;

    const price =
      card.querySelector('product-price') || card.querySelector('.price-block');
    if (!price || !price.parentElement || price.contains(this)) return;

    price.parentElement.insertBefore(this, price);
    this.dataset.positioned = 'true';
  }
}

if (!customElements.get('review-rating')) {
  customElements.define('review-rating', ReviewRating);
}

// Safety net: catch any elements that existed before the class was defined
// (modules load asynchronously, so the elements may already be in the DOM)
function positionAll() {
  document
    .querySelectorAll('review-rating[data-position="above-price"]:not([data-positioned="true"])')
    .forEach((el) => {
      if (el instanceof ReviewRating) {
        el.positionSelf();
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', positionAll);
} else {
  positionAll();
}

// Catch cards added dynamically (facets, pagination, predictive search)
const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (node.matches?.('review-rating[data-position="above-price"]')) {
        node instanceof ReviewRating && node.positionSelf();
      } else {
        node
          .querySelectorAll?.('review-rating[data-position="above-price"]:not([data-positioned="true"])')
          .forEach((el) => el instanceof ReviewRating && el.positionSelf());
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
